import {
  GET_ACCOUNT_OWNERS,
  GET_ACCOUNT_OWNERS_FAILURE,
  GET_ACCOUNT_OWNERS_SUCCESS,
} from '../actions'
import { AccountOwner, AccountOwnerState } from '../types'
import { INITIAL_ACCOUNT_OWNERS_STATE } from '../containers/contexts/search'

export const accountOwnersReducer = (
  state: AccountOwnerState = INITIAL_ACCOUNT_OWNERS_STATE,
  action: {
    type: string
    accountOwners?: AccountOwner[]
  }
) => {
  const { type, accountOwners = [] } = action
  switch (type) {
    case GET_ACCOUNT_OWNERS:
      return {
        ...INITIAL_ACCOUNT_OWNERS_STATE,
        loadingAccountOwners: true,
      }
    case GET_ACCOUNT_OWNERS_SUCCESS:
      return {
        ...state,
        loadingAccountOwners: false,
        accountOwners,
      }
    case GET_ACCOUNT_OWNERS_FAILURE:
      return {
        ...state,
        loadingAccountOwners: false,
      }
    default:
      return state
  }
}
